import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { RevenueCategory, RevenueCategoryWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateRevenueCategory(): UseMutationResult<
  AxiosResponse<RevenueCategory>,
  AxiosError<ErrorMessage>,
  RevenueCategoryWrite
> {
  const queryClient = useQueryClient();

  const updateRevenueCategory = useCallback(
    (category: RevenueCategoryWrite): Promise<AxiosResponse<RevenueCategory>> => {
      return client.put(`revenue-categories/${category.revenueCategoryId}/`, category);
    },
    [],
  );

  return useMutation(updateRevenueCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries(['revenue-categories-autocomplete']);
      queryClient.invalidateQueries(['packageRevenueCategories']);
      queryClient.invalidateQueries(['revenueCategories']);
    },
  });
}
